import type { ObservableValue } from '@amazon/vinyl-observable'
import { externalData } from '@amazon/vinyl-observable'
import { type RequesterImpl, RequestFailureType, signal } from '@amazon/vinyl-util'
import { createDisposer, onLine, requesterWithRetryRef, type Unsubscribe } from '@amazon/vinyl-util'
import { isOnline } from '@/util/offlineUtil'

const networkErrors = signal<void>()

/** Marks the network bad until the next completed request or online transition. */
export function reportNetworkError(): void {
    networkErrors.dispatch()
}

export function createGoodNetworkObservable(): ObservableValue<boolean> {
    return externalData(onLine(), (setData: (value: boolean) => void): Unsubscribe => {
        // Network is considered good or bad based on the last event of either a network request
        // completing, the network online status changing, or a reported network error.
        const { add, dispose } = createDisposer()
        const requester = requesterWithRetryRef.value as RequesterImpl
        add(
            requester.on('requestAttemptComplete', (event) => {
                if (!onLine()) return
                if (event.ok || event.type === RequestFailureType.INTERNAL) setData(event.ok)
            })
        )
        add(isOnline().onData(setData))
        add(networkErrors.listen(() => setData(false)))
        return dispose
    })
}
